module.exports = __webpack_public_path__ + "static/cappuccino-c98fdedf276dbd1ffc78fc73a76f93d9.png";